<template>
  <!-- <div class="no-content">
    <div class="ccui-error-pic">
      <img
        src="@/assets/images/cardNo.png"
        alt="cardNo"
        width="559px"
        height="337px"
      />
    </div>
    <div class="ccui-error-detail">
      <div class="ccui-error-detail-text">购物车空空如也，请去挑选些商品吧</div>
      <div>
        <a class="goTo" @click="goBack">
          去逛逛
        </a>
      </div>
    </div>
  </div> -->
  <div class="ccui-error-404-mains">
    <div class="ccui-error-404__pic">
      <img
        src="@/assets/images/cardNo.png"
        alt="cardNo"
        width="559px"
        height="337px"
      />
    </div>
    <div class="ccui-error-404-detail">
      <div class="ccui-error-404-detail-text">
        购物车空空如也，请去挑选些商品吧
      </div>
      <a class="ccui-error-404-detail-button" @click="goBack"> 去逛逛 </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoContent",
  data() {
    return {};
  },
  methods: {
    goBack() {
      if (
        [
          "/inquiry-price-goods-cloud-rent/index",
          "/inquiry-price-plans-cloud-rent/index"
        ].includes(this.$route.path)
      ) {
        window.location.href =
          this.$addUrlPerFix(process.env.VUE_APP_CLP_URL) + "/direct-rent/list";
      } else {
        window.location.href = this.$addUrlPerFix(process.env.VUE_APP_EMP_URL);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ccui-error-404-mains {
  width: 1000px;
  height: 400px;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.ccui-error-404-mains .ccui-error-404__pic {
  float: left;
  margin-top: 28px;
}

.ccui-error-404-mains .ccui-error-404-detail {
  display: inline-block;
  margin-top: 126px;
}

.ccui-error-404-mains .ccui-error-404-detail .ccui-error-404-detail-top {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  height: 33px;
  line-height: 33px;
  font-family: PingFangSC-Semibold, PingFang SC;
}

.ccui-error-404-mains .ccui-error-404-detail .ccui-error-404-detail-text {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9b9b9b;
  height: 35px;
  line-height: 35px;
  margin-top: 13px;
}

.ccui-error-404-detail-button {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0091ff;
  text-decoration: underline;
}
</style>
